import { CanMatchFn } from '@angular/router';
import { inject } from '@angular/core';
import { map } from 'rxjs/operators';
import { AuthService } from '../auth.service';

/**
 * canMatch guard for guest-only routes (login, register, etc.).
 * Returns true when user is NOT authenticated → route matches for guests.
 * Returns false when user IS authenticated → route skipped, falls to auth routes.
 */
export const noAuthMatch: CanMatchFn = () => {
  const authService = inject(AuthService);
  return authService.check().pipe(map((authenticated) => !authenticated));
};
